import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Products from "./Products";
import Suppliers from "./Suppliers";
import Customers from "./Customers";
import Purchase from "./Purchase";
import Sale from "./Sale";
import Receipt from "./Receipt";
import Voucher from "./Voucher";
import SalesReport from "./SalesReport";
import PurchaseReport from "./PurchaseReport";
import AccountReport from "./AccountReport";
import StockReport from "./StockReport";
import FirmSettings from "./FirmSettings";
import UserSettings from "./UserSettings";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/products" element={<Products />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/purchase" element={<Purchase />} />
        <Route path="/sale" element={<Sale />} />
        <Route path="/receipt" element={<Receipt />} />
        <Route path="/voucher" element={<Voucher />} />
        <Route path="/reports/sale" element={<SalesReport />} />
        <Route path="/reports/purchase" element={<PurchaseReport />} />
        <Route path="/reports/account" element={<AccountReport />} />
        <Route path="/reports/stock" element={<StockReport />} />
        <Route path="/settings/firm" element={<FirmSettings />} />
        <Route path="/settings/user" element={<UserSettings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
